import { AngularFirestore } from 'angularfire2/firestore';
import { DataModel, IDataModel } from './data.model'



export interface INaoEncontrei extends IDataModel {
    fornecedor?:number,
    usuario?:string,
    marca?:string,
    nome?: string,
    avisar?: boolean,
    contato?: string,
    arquivado?:boolean,
}

export class NaoEncontrei extends DataModel<INaoEncontrei>  {
    fFornecedor:number=0;
    
    get fornecedor():number{
        return this.fFornecedor;
    }
    set fornecedor(x:number){
        //console.log('class: ',x);
        if (x>=0) {
          this.getItems(x,null);
        }
    }

    get items(){
       return this.FDados;
    }

    constructor(private db: AngularFirestore,
       private aFornecedor:number) {
        super(db,'naoEncontrei');
       this.fornecedor = aFornecedor;
    }

    add(item, proc?: any, errProc?: any): Promise<any> {
        item.data = new Date();
        item.arquivado = false;
        return super.add(item,proc,errProc);
    }

    comentar(id,comentario:string){
         this.db.collection(this.tableNameFull)
                  .doc(id).ref.collection("comentarios")
                  .add({comentario:comentario,data:new Date(),usuario:this.user.email, leu:false});
         super.update(id,{arquivado:false});
    } 

    enviarMensagem(contato,titulo,comentario:string, fornecedor=0){
      return this.add({
          avisar: false,
          contato:contato,
          fornecedor:fornecedor,
          titulo:titulo,
          texto:comentario,
      })       
    }

    getComentarios(id,pSubscribe){
        let qry = this.db.collection(this.tableNameFull)
          .doc(id).ref.collection("comentarios");
          qry.orderBy("data","desc").limit(20);
          this.openQuery(qry,pSubscribe);
          return qry;
    }

   getItems(forn:number,proc?){
      let rt=null ;
      
      this.fFornecedor= forn;

      //console.log('getItems: ',forn);

      this.FDados.forEach(element => {
           if (element.fornecedor==this.fornecedor){
               rt = element;
               if (proc!=null) proc(rt) 
               else 
                 this.changedEvent.next(this.FDados);
               return rt;
           }
       });  

      /// nao esta na memoria ?
   //   if (rt==null){
        this.snapshot(
            r => r.where("fornecedor","==",Number(this.fornecedor))
            .where("arquivado","==",false)
        ,(d)=>
        {
          //console.log(d);  
          this.changedEvent.next(d);  
        });  
  //    }

   }
   
}
